import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  videoContainer: {
    height: 480,
    width: '100%',
  },
  video: {
    padding: 0,
    margin: 0,
    borderTop: 'none',
    width: '100%',
    height: 480,
  },
}));

function Video({ video }) {
  const classes = useStyles();
  return (
    <div className={classes.videoContainer}>
      <iframe
        className={classes.video}
        src={video}
        title="video player"
        marginHeight="0"
        frameBorder="0"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}

export default Video;

Video.propTypes = {
  video: PropTypes.string.isRequired,
};
